import { render, staticRenderFns } from "./IconStatus.vue?vue&type=template&id=8704f974&lang=pug"
import script from "./IconStatus.vue?vue&type=script&lang=js"
export * from "./IconStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports